// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookPage_wrapper__d4q0R {
    width: 100%;
    min-height: 100vh;
    background-color: #CAC9C9;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  
  .BookPage_readerContainer__BKqAO {
    width: 100%;
    max-width: 1000px;
    height: 90vh;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
  }
  
  .BookPage_topNav__ID7GI {
    background: #000;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 2;
  }
  
  .BookPage_chaptersBtn__Ky619 {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: transparent;
    color: white;
    border: 1.5px solid white;
    border-radius: 20px;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .BookPage_chaptersBtn__Ky619:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  
  .BookPage_closeBtn__lhcsV {
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
    padding: 0.5rem;
  }
  
  .BookPage_mainContent__kwxW0 {
    flex: 1 1;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
  }
  
  .BookPage_bookTitle__KAJJj {
    font-size: 2.5rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 2rem;
    color: #1a1a1a;
  }
  
  .BookPage_contentScroll__2u\\+vo {
    flex: 1 1;
    overflow-y: scroll;
    padding-right: 2rem;
    margin-right: -2rem; /* Compensate for padding to align text */
    position: relative;
    height: calc(100% - 120px); /* Account for title and navigation */
  }
  
  /* Visible scrollbar styling */
  .BookPage_contentScroll__2u\\+vo::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
  }
  
  .BookPage_contentScroll__2u\\+vo::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 4px;
  }
  
  .BookPage_contentScroll__2u\\+vo::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }
  
  .BookPage_contentScroll__2u\\+vo::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
  
  /* Firefox scrollbar */
  .BookPage_contentScroll__2u\\+vo {
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
  }
  
  .BookPage_paragraph__CYolF {
    margin-bottom: 1.5rem;
    line-height: 1.8;
    font-size: 1.1rem;
    color: #333;
    padding-right: 1rem;
  }
  
  .BookPage_pageNavigation__oTgq5 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
  }
  
  .BookPage_navButton__3EVRs {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    color: #333;
    transition: all 0.2s ease;
  }
  
  .BookPage_pageNumber__QXvhN {
    font-size: 1.2rem;
    color: #666;
    font-weight: 500;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .BookPage_wrapper__d4q0R {
      padding: 0;
    }
  
    .BookPage_readerContainer__BKqAO {
      height: 100vh;
      border-radius: 0;
    }
  
    .BookPage_mainContent__kwxW0 {
      padding: 1.5rem;
    }
  
    .BookPage_bookTitle__KAJJj {
      font-size: 2rem;
      margin-bottom: 1.5rem;
    }
  
    .BookPage_contentScroll__2u\\+vo {
      padding-right: 1.5rem;
      margin-right: -1.5rem;
    }
  
    .BookPage_paragraph__CYolF {
      font-size: 1rem;
      line-height: 1.6;
    }
  }
  
  @media (max-width: 480px) {
    .BookPage_topNav__ID7GI {
      padding: 0.75rem 1rem;
    }
  
    .BookPage_chaptersBtn__Ky619 {
      font-size: 0.8rem;
      padding: 0.4rem 0.8rem;
    }
  
    .BookPage_mainContent__kwxW0 {
      padding: 1rem;
    }
  
    .BookPage_contentScroll__2u\\+vo {
      padding-right: 1rem;
      margin-right: -1rem;
    }
  
    .BookPage_pageNavigation__oTgq5 {
      padding: 1rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/demo/BookPage.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8EAA8E;EAChF;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB,EAAE,yCAAyC;IAC9D,kBAAkB;IAClB,0BAA0B,EAAE,qCAAqC;EACnE;;EAEA,8BAA8B;EAC9B;IACE,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,sBAAsB;EACtB;IACE,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;EAC7B;;EAEA,sBAAsB;EACtB;IACE;MACE,UAAU;IACZ;;IAEA;MACE,aAAa;MACb,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;MACrB,qBAAqB;IACvB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,qBAAqB;IACvB;;IAEA;MACE,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;EACF","sourcesContent":[".wrapper {\n    width: 100%;\n    min-height: 100vh;\n    background-color: #CAC9C9;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  }\n  \n  .readerContainer {\n    width: 100%;\n    max-width: 1000px;\n    height: 90vh;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .topNav {\n    background: #000;\n    padding: 1rem 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 2;\n  }\n  \n  .chaptersBtn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: transparent;\n    color: white;\n    border: 1.5px solid white;\n    border-radius: 20px;\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n  \n  .chaptersBtn:hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n  \n  .closeBtn {\n    background: transparent;\n    border: none;\n    color: white;\n    cursor: pointer;\n    padding: 0.5rem;\n  }\n  \n  .mainContent {\n    flex: 1;\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .bookTitle {\n    font-size: 2.5rem;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 2rem;\n    color: #1a1a1a;\n  }\n  \n  .contentScroll {\n    flex: 1;\n    overflow-y: scroll;\n    padding-right: 2rem;\n    margin-right: -2rem; /* Compensate for padding to align text */\n    position: relative;\n    height: calc(100% - 120px); /* Account for title and navigation */\n  }\n  \n  /* Visible scrollbar styling */\n  .contentScroll::-webkit-scrollbar {\n    width: 8px;\n    background-color: transparent;\n  }\n  \n  .contentScroll::-webkit-scrollbar-track {\n    background-color: #f1f1f1;\n    border-radius: 4px;\n  }\n  \n  .contentScroll::-webkit-scrollbar-thumb {\n    background-color: #888;\n    border-radius: 4px;\n  }\n  \n  .contentScroll::-webkit-scrollbar-thumb:hover {\n    background-color: #555;\n  }\n  \n  /* Firefox scrollbar */\n  .contentScroll {\n    scrollbar-width: thin;\n    scrollbar-color: #888 #f1f1f1;\n  }\n  \n  .paragraph {\n    margin-bottom: 1.5rem;\n    line-height: 1.8;\n    font-size: 1.1rem;\n    color: #333;\n    padding-right: 1rem;\n  }\n  \n  .pageNavigation {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 2rem;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: white;\n  }\n  \n  .navButton {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0.5rem;\n    color: #333;\n    transition: all 0.2s ease;\n  }\n  \n  .pageNumber {\n    font-size: 1.2rem;\n    color: #666;\n    font-weight: 500;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .wrapper {\n      padding: 0;\n    }\n  \n    .readerContainer {\n      height: 100vh;\n      border-radius: 0;\n    }\n  \n    .mainContent {\n      padding: 1.5rem;\n    }\n  \n    .bookTitle {\n      font-size: 2rem;\n      margin-bottom: 1.5rem;\n    }\n  \n    .contentScroll {\n      padding-right: 1.5rem;\n      margin-right: -1.5rem;\n    }\n  \n    .paragraph {\n      font-size: 1rem;\n      line-height: 1.6;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .topNav {\n      padding: 0.75rem 1rem;\n    }\n  \n    .chaptersBtn {\n      font-size: 0.8rem;\n      padding: 0.4rem 0.8rem;\n    }\n  \n    .mainContent {\n      padding: 1rem;\n    }\n  \n    .contentScroll {\n      padding-right: 1rem;\n      margin-right: -1rem;\n    }\n  \n    .pageNavigation {\n      padding: 1rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `BookPage_wrapper__d4q0R`,
	"readerContainer": `BookPage_readerContainer__BKqAO`,
	"topNav": `BookPage_topNav__ID7GI`,
	"chaptersBtn": `BookPage_chaptersBtn__Ky619`,
	"closeBtn": `BookPage_closeBtn__lhcsV`,
	"mainContent": `BookPage_mainContent__kwxW0`,
	"bookTitle": `BookPage_bookTitle__KAJJj`,
	"contentScroll": `BookPage_contentScroll__2u+vo`,
	"paragraph": `BookPage_paragraph__CYolF`,
	"pageNavigation": `BookPage_pageNavigation__oTgq5`,
	"navButton": `BookPage_navButton__3EVRs`,
	"pageNumber": `BookPage_pageNumber__QXvhN`
};
export default ___CSS_LOADER_EXPORT___;
